import React, { forwardRef, memo, useMemo } from "react";
import { NavbarItems } from "./constants/Dropdown.constants.tsx";
import RotaItem from "./components/DropdownRotaItem.tsx";
import DropdownSection from "./components/DropdownSection.tsx";
import {
  GestaoItemsEnum,
  NavbarItemsEnum,
} from "./interfaces/Dropdown.enum.ts";
import DropdownSectionCombined from "./components/DropdownSectionCombined.tsx";

interface DropdownPessoasProps {
  ref: React.RefObject<HTMLDivElement>;
}

const DropdownPessoas = forwardRef<HTMLDivElement, DropdownPessoasProps>(
  ({}, ref) => {
    const gestaoItemsSections =
      NavbarItems[NavbarItemsEnum.GESTAOITEMS].sections;

    const gestaoPessoasItems =
      gestaoItemsSections[GestaoItemsEnum.GESTAOPESSOAS].items;

    const usuariosItems = gestaoItemsSections[GestaoItemsEnum.USUARIOS].items;

    const gestaoVeiculosItems =
      gestaoItemsSections[GestaoItemsEnum.GESTAOVEICULOS].items;

    const checklistItems = gestaoItemsSections[GestaoItemsEnum.CHECKLIST].items;

    const usoComumItems = gestaoItemsSections[GestaoItemsEnum.USOCOMUM].items;

    const memorizedGestaoPessoasItems = useMemo(() => {
      return gestaoPessoasItems.map((item) => (
        <div key={`gestaoPessoas-${item.rota}`} className="botao-menu-cte">
          <RotaItem key={`gestaoPessoas-${item.rota}`} item={item} />
        </div>
      ));
    }, [gestaoPessoasItems]);

    const memorizedUsuariosItems = useMemo(() => {
      return usuariosItems.map((item) => (
        <div key={`usuarios-${item.rota}`} className="botao-menu-cte">
          <RotaItem key={`usuarios-${item.rota}`} item={item} />
        </div>
      ));
    }, [usuariosItems]);

    const memorizedGestaoVeiculosItems = useMemo(() => {
      return gestaoVeiculosItems.map((item) => (
        <div key={`gestaoVeiculos-${item.rota}`} className="botao-menu-cte">
          <RotaItem key={`gestaoVeiculos-${item.rota}`} item={item} />
        </div>
      ));
    }, [gestaoVeiculosItems]);

    const memorizedChecklistItems = useMemo(() => {
      return checklistItems.map((item) => (
        <div key={`checklist-${item.rota}`} className="botao-menu-cte">
          <RotaItem key={`checklist-${item.rota}`} item={item} />
        </div>
      ));
    }, [checklistItems]);

    const memorizedUsoComumItems = useMemo(() => {
      return usoComumItems.map((item) => (
        <div key={`usoComum-${item.rota}`} className="botao-menu-cte">
          <RotaItem key={`usoComum-${item.rota}`} item={item} />
        </div>
      ));
    }, [usoComumItems]);

    return (
      <div className="dropdown-content-emb">
        <div className="separador-menu-gestao" />
        <div className="content-menu-rows">
          <DropdownSectionCombined
            titleSection1={
              gestaoItemsSections[GestaoItemsEnum.GESTAOPESSOAS].titleSection
            }
            icon1={gestaoItemsSections[GestaoItemsEnum.GESTAOPESSOAS].icon}
            titleSection2={
              gestaoItemsSections[GestaoItemsEnum.USUARIOS].titleSection
            }
            icon2={gestaoItemsSections[GestaoItemsEnum.USUARIOS].icon}
            children1={memorizedGestaoPessoasItems}
            children2={memorizedUsuariosItems}
          />

          <DropdownSectionCombined
            titleSection1={
              gestaoItemsSections[GestaoItemsEnum.GESTAOVEICULOS].titleSection
            }
            icon1={gestaoItemsSections[GestaoItemsEnum.GESTAOVEICULOS].icon}
            titleSection2={
              gestaoItemsSections[GestaoItemsEnum.CHECKLIST].titleSection
            }
            icon2={gestaoItemsSections[GestaoItemsEnum.CHECKLIST].icon}
            children1={memorizedGestaoVeiculosItems}
            children2={memorizedChecklistItems}
          />
          <DropdownSection
            titleSection={
              gestaoItemsSections[GestaoItemsEnum.USOCOMUM].titleSection
            }
            icon={gestaoItemsSections[GestaoItemsEnum.USOCOMUM].icon}
            children={memorizedUsoComumItems}
          />
        </div>
      </div>
    );
  }
);

export default memo(DropdownPessoas);
